import {axios} from '@/api/axios';
import {AxiosResponse} from 'axios';
import {VIDEO_URLS} from '@/api/urls';
import {formatString} from '@/utils';
import {Channel} from '@/types/channel';
import {Video} from '@/types/video';

export const VideoApi = {
  getList: () => axios.get<Video[]>(VIDEO_URLS.GET_LIST),
  getOne: (channelId: string) => axios.get<Video>(formatString(VIDEO_URLS.GET_ONE, channelId)),
  save: (data: any) => axios.post<Required<Video>>(VIDEO_URLS.SAVE, data),
  edit: (channelId: string, data: Video) => axios.put<AxiosResponse<Channel>>(formatString(VIDEO_URLS.EDIT, channelId), data)
};
